import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, popupSales } from '../data/content';
export function SalesPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: ReturnType<typeof setTimeout>;
    const cycle = (i: number) => {
      timeout = setTimeout(() => {
        setIndex(i % popupSales.length);
        setVisible(true);
        timeout = setTimeout(() => {
          setVisible(false);
          cycle(i + 1);
        }, 5200);
      }, 3200);
    };
    cycle(0);
    return () => clearTimeout(timeout);
  }, [dismissed]);
  const sale = popupSales[index];
  return <AnimatePresence data-id="element-135" data-mp="1dpovuhvciwkj">
      {visible && !dismissed ? <motion.aside initial={{
      opacity: 0,
      y: 14,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 14,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-2 left-2 z-50 w-60 overflow-hidden rounded-lg border-[3px] border-magenta bg-white shadow-xl ring-2 ring-electric sm:w-72" aria-live="polite" data-id="element-136" data-mp="18q2i87blveb7">
          <div className="flex items-center gap-1.5 bg-magenta px-2 py-1" data-id="element-137" data-mp="2ehaicqe8vjvw">
            <span className="text-sm leading-none" aria-hidden="true" data-id="element-138" data-mp="2iivrq1rklg1c">
              🔬
            </span>
            <p className="font-heading text-[0.6rem] font-extrabold uppercase tracking-widest text-white" data-id="element-139" data-mp="2ng5s2cghzc3y">
              New purchase verified
            </p>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="ml-auto text-white/80 transition-colors duration-150 ease-out hover:text-white" data-id="element-140" data-mp="2xfd32szreunw">
              <XIcon className="h-3 w-3" aria-hidden="true" data-id="element-141" data-mp="131vm5otv0w1u" />
            </button>
          </div>
          <a href={PURCHASE_ANCHOR} className="block px-2 py-1.5" data-id="element-142" data-mp="v164blx0kg94">
            <p className="text-xs font-bold leading-tight text-navy" data-id="element-143" data-mp="q2cuc3gxr7dp">
              {sale.name} just bought HISTOLOGY &amp; PATHOLOGY VISUAL ATLAS™
            </p>
            <p className="mt-0.5 text-[0.65rem] font-semibold text-ink/70" data-id="element-144" data-mp="zzqwcy243tmh">
              {sale.city}, {sale.country} • a few minutes ago
            </p>
          </a>
        </motion.aside> : null}
    </AnimatePresence>;
}